
import {Product} from "@/models/base";
import Vue from "vue";
import {AuthService, DossierConfigService} from "@/services";
import {MODULE} from "@/config/modules";
import AppProductEditIntrastatData from "./ProductEditIntrastatData.vue";
import { TaxesConfig } from "@/models/dossier-configs/taxes-config";

export default Vue.extend({
	props: {
		product: {
			type: Object as () => Product,
			required: true
		}
	},
	computed: {
		hasLeeggoedModule(): boolean {
			return AuthService.hasModule(MODULE.DRANKENCENTRALE);
		},
		taxSettings():TaxesConfig {
			return DossierConfigService.getTaxesConfig();
		},
		vatExclusiveTaxLabel():string{
			if (this.taxSettings.ProductCustomVatExclusiveTaxLabelName){
				return this.taxSettings.ProductCustomVatExclusiveTaxLabelName;
			}
			return this.$ct("labels.custom-vat-exclusive-tax").toString();
		},
		vatInclusiveTaxLabel():string{
			if (this.taxSettings.ProductCustomVatInclusiveTaxLabelName){
				return this.taxSettings.ProductCustomVatInclusiveTaxLabelName;
			}
			return this.$ct("labels.custom-vat-inclusive-tax").toString();
		}
	},
	components: {
		AppProductEditIntrastatData
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
